import React from "react";
import { Spin } from "antd";
import { Viewer, Worker, SpecialZoomLevel } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "./PdfPreview.css";

const WORKER_URL = "https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js";

export default function PdfPreview({
  fileUrl,
  loading = false,
  height = "80vh",
  scaleType = "PageWidth",
}) {
  if (!fileUrl) {
    if (!loading) return null;
    return (
      <div className="PdfPreview__Loading" style={{ height }}>
        <Spin />
      </div>
    );
  }

  return (
    <div className="PdfPreview__Container" style={{ height }}>
      <Worker workerUrl={WORKER_URL}>
        <Viewer
          fileUrl={fileUrl}
          defaultScale={SpecialZoomLevel[scaleType]}
          renderLoader={() => (
            <div className="PdfPreview__Loading" style={{ height }}>
              <Spin />
            </div>
          )}
        />
      </Worker>
    </div>
  );
}
